import '../assets/js/main.js';
import $ from 'jquery';
import React, { useEffect, useState } from 'react';
import { NavLink } from "react-router-dom";

const Footer = () => {
    return (
        <>
            <footer className="footer">
                <div className="container">
                    <div className="row">
                        <div className="footer-col">
                            <h4>Firma</h4>
                            <ul>
                                <li><NavLink to="/about">o nas</NavLink></li>
                                <li><NavLink to="/privacy">polityka prywatności</NavLink></li>
                            </ul>
                        </div>
                        <div className="footer-col">
                            <h4>Kategorie</h4>
                            <ul>
                                <li><NavLink to="/">dropy</NavLink></li>
                                <li><NavLink to="/sale">wyprzedaż</NavLink></li>
                                <li><NavLink to="/raffles">losowania</NavLink></li>
                                <li><NavLink to="/news">nowości</NavLink></li>
                            </ul>
                        </div>
                        <div className="footer-col">
                            <h4>Pomoc</h4>
                            <ul>
                                <li><NavLink to="/faq">FAQ</NavLink></li>
                                <li><a href="mailto:kontakt@drops0n.pl">kontakt</a></li>
                            </ul>
                        </div>
                        <div className="footer-col">
                            <h4>Zaobserwuj nas</h4>
                            <div className="social-links">
                                <a href="https://www.instagram.com/dropsoon.pl/"><i className="fab fa-instagram"></i></a>
                                <a href="https://www.tiktok.com/dropsoon"><i className="fab fa-tiktok"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Footer;